import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  const loc = useLocation();
  if (checking) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center text-[10px] uppercase tracking-[0.28em] text-navy-600/60">
        Verifying session…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: loc.pathname }} replace />;
  }
  return children;
}
